import { render } from "./FullFooter.vue?vue&type=template&id=6d3d226d&scoped=true"
import script from "./FullFooter.vue?vue&type=script&lang=js"
export * from "./FullFooter.vue?vue&type=script&lang=js"

import "./FullFooter.vue?vue&type=style&index=0&id=6d3d226d&scoped=true&lang=css"

import exportComponent from "/Users/alekseisemiguk/Documents/sadko/35FIT-full/35FIT/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d3d226d"]])

export default __exports__